module.exports = __webpack_public_path__ + "static/media/RE_HabitCards.74ad20c5.png";